import classNames from "classnames";
import style from "./AppSearchFilters.module.scss";
import { useSelector } from "react-redux";
import { selectTopicResults } from "../../../features/enhancedSearch";
import { useEffect, useState } from "react";
import AppGuidelineItem from "./AppGuidelineItem";
import PropTypes from "prop-types";

const AppSearchFilters = ({ setShowFilters, search, navigate }) => {
  const searchResults = useSelector(selectTopicResults);
  const [selectedGuidelines, setSelectedGuidelines] = useState([]);
  const [guidelinesLoaded, setGuidelinesLoaded] = useState(false);

  const updateResults = () => {
    const selectedGuideline = selectedGuidelines[0];
    const searchParams = new URLSearchParams(search);
    if (selectedGuideline === undefined) {
      if (searchParams.has("appendedinputbuttons")) {
        const urlSearch = searchParams.get("appendedinputbuttons");
        navigate(`/searchAction/?appendedinputbuttons=${encodeURIComponent(urlSearch)}`);
      }
    } else {
      if (searchParams.has("appendedinputbuttons")) {
        const urlSearch = searchParams.get("appendedinputbuttons");
        navigate(`/searchAction/?appendedinputbuttons=${encodeURIComponent(urlSearch)}&guidelinefilter=${encodeURIComponent(selectedGuideline)}`);
      }
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const guidelineFilter = searchParams.get("guidelinefilter");
    if (guidelineFilter) {
      setSelectedGuidelines([guidelineFilter]);
    }
    setGuidelinesLoaded(true)
  }, [search]);

  return (
    <div className={classNames("size-14", style.filterContainer)}>
      <div>
        <div className={style.header}>
          <button
            className={style.closeButton}
            type="button"
            onClick={() => setShowFilters(false)}
            data-testid="crossButton"
          >
            <i className="tg-icons-Cross size-24"></i>
          </button>
          <div className="size-22">Filter</div>
          <button
            className={classNames("semibold", style.clearButton)}
            onClick={() => setSelectedGuidelines([])}
            type="button"
          >
            Clear
          </button>
        </div>
        <div className={classNames("bold", style.guidelineHeader)}>
          Guidelines
        </div>
      </div>
      <div className={style.filters}>
        <ul className={style.guidelineList}>
          {guidelinesLoaded &&
            searchResults?.guidelineFacets &&
            Object.keys(searchResults.guidelineFacets).map((title) => (
              <AppGuidelineItem
                guideline={title}
                resultCount={searchResults.guidelineFacets[title]}
                selectedGuideline={selectedGuidelines}
                key={title}
                updateSelected={setSelectedGuidelines}
              />
            ))}
        </ul>
      </div>
      <div className={style.buttonSection}>
        <div className={style.buttonDiv}>
          <button onClick={updateResults} className={style.showResultsButton}>
            Show results
          </button>
        </div>
        <div className={style.buttonDiv}>
          <button
            className={style.cancelButton}
            onClick={() => setShowFilters(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

AppSearchFilters.propTypes = {
  setShowFilters: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default AppSearchFilters;
